import * as PIXI from "pixi.js";
import $ from "jquery";
import Cookies from "js-cookie";
import gsap from "gsap";
import EventEmitter from "eventemitter3";
import EnvUtil from "../util/EnvUtil";
import RankingManager from "../ranking/RankingManager";
import AsseetsManager from "../pixi/AssetsManager";

enum SEND_BTN_STATUS {
  DISABLE,
  ACTIVE,
  SENDING,
  DONE,
}

/**
 * GameOverViewクラス
 */
class GameOverView extends EventEmitter {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //DOM
  private _container: JQuery;
  private _sendBtn: JQuery;
  private _wrapper: JQuery;
  private _retryBtn: JQuery;
  private _rankingBtn: JQuery;
  private _input: JQuery;

  //送信済みフラグ
  private _sendedFlag: boolean;

  //スコア
  private _score: number;

  //ステータス
  private _status: SEND_BTN_STATUS;

  //テキストチェックメソッド
  private _updateSendButton: any;

  // ---------------------------------------------------------------------------------------------------------
  // --	GameOverView
  // ---------------------------------------------------------------------------------------------------------
  /**
   * コンストラクタ
   */
  constructor() {
    super();

    //DOM参照
    this._container = $("#gameover");
    this._wrapper = $(".c-gameover__wrapper");
    this._sendBtn = $(".c-gameover__send-btn");
    this._retryBtn = $(".c-gameover__retry-btn");
    this._rankingBtn = $(".c-gameover__ranking-btn");

    //ボタンアクション
    this._sendBtn.on("click", (e) => {
      e.preventDefault();
      this.sendScore();
    });
    this._retryBtn.on("click", (e) => {
      e.preventDefault();
      this.emit("RETRY");
    });
    this._rankingBtn.on("click", (e) => {
      e.preventDefault();
      this.emit("RANKING");
    });

    //メソッド保存
    this._updateSendButton = this.updateSendButton.bind(this);

    //リセット
    this.reset();
  }

  /**
   * リセット
   */
  reset() {
    //Tween停止
    gsap.killTweensOf(this._container);

    //全体非表示
    this._container.hide();

    //ラッパー初期化
    this._wrapper.removeClass("show");

    //ステータス初期化
    this._status = SEND_BTN_STATUS.DISABLE;

    //送信ボタンの表示更新
    this.updateSendBtnView();
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	METHOD
  // ---------------------------------------------------------------------------------------------------------

  /**
   * 開く
   */
  open(score: number, str: string = "") {
    //SE
    AsseetsManager.instance.playSound("sound_over");

    //スコア保持
    this._score = score;

    //スコア表示
    $("#num-score").text(String(score));

    //ハイスコア
    let hiscore: number = Cookies.get("hiscore") ? Cookies.get("hiscore") : 0;
    if (this._score > hiscore) {
      hiscore = this._score;
      Cookies.set("hiscore", hiscore);
    }
    $("#num-hiscore").text(String(hiscore));

    //コンテナ表示
    gsap.set(this._container, { opacity: 0 });
    gsap.to(this._container, {
      duration: 0.3,
      opacity: 1,
      ease: "none",
      onComplete: () => {
        this._wrapper.addClass("show");
        this.textCheckStart();
      },
    });
    this._container.show();
  }

  /**
   * 閉じる
   */
  clsoe() {
    //リセット
    this.reset();

    //テキストチェック停止
    this.textCheckStop();
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	入力チェック
  // ---------------------------------------------------------------------------------------------------------

  /**
   * テキストチェック開始
   */
  textCheckStart() {
    //DOM の　input 要素
    const $inputElm: JQuery = $("#name-input");

    // 文字列チェック用の正規表現
    const alloweStrings: RegExp = /[^A-Za-z]+/;

    //KeyUpイベント
    $inputElm.on("keyup", (e) => {
      //Android端末以外は入力ごとにDOM input要素を更新
      if (EnvUtil.isAndroid) {
        this.updateDOMInput($inputElm, alloweStrings);
      }

      //実行キーが押された時は入力フィールドのフォーカスをはずす
      if (e.keyCode == 13) {
        $inputElm.blur();
      }
    });

    //入力フィールドのフォーカスがはずれた時にチェック
    $inputElm.on("blur", (e) => {
      this.updateDOMInput($inputElm, alloweStrings);
    });

    //チェック開始
    PIXI.Ticker.shared.add(this._updateSendButton);
  }

  /**
   * テキストチェック停止
   */
  textCheckStop() {
    //DOM の　input 要素
    const $inputElm: JQuery = $("#name-input");

    //リスナー削除
    $inputElm.off("keyup");
    $inputElm.off("blur");

    //チェック停止
    PIXI.Ticker.shared.remove(this._updateSendButton);
  }

  /**
   * DOM input要素のバリデーション
   */
  updateDOMInput($inputElm: JQuery, alloweStrings: RegExp) {
    //テキストのバリデーション
    const inputText: string = String($inputElm.val());
    let text = inputText.replace(alloweStrings, "");
    text = text.toUpperCase();

    // 置換する
    if (text !== inputText) {
      $inputElm.val(text);
    }

    //送信ボタン表示更新
    this.updateSendButton();
  }

  /**
   * 送信ボタンの表示更新
   */
  updateSendButton() {
    if (
      this._status == SEND_BTN_STATUS.SENDING ||
      this._status == SEND_BTN_STATUS.DONE
    )
      return;

    //DOM の　input 要素
    const $inputElm: JQuery = $("#name-input");

    // 文字列チェック用の正規表現
    const alloweStrings: RegExp = /[^A-Za-z]+/;

    //OKボタンのステータス変更
    const inputText: string = String($inputElm.val());
    const text: string = inputText.replace(alloweStrings, "");
    if (text !== "") {
      this._status = SEND_BTN_STATUS.ACTIVE;
    } else {
      this._status = SEND_BTN_STATUS.DISABLE;
    }

    //ボタンの表示更新
    this.updateSendBtnView();
  }

  /**
   * 送信ボタンの表示更新
   */
  updateSendBtnView(): void {
    switch (this._status) {
      case SEND_BTN_STATUS.DISABLE:
        this._sendBtn.removeClass("active");
        this._sendBtn.removeClass("sending");
        this._sendBtn.removeClass("done");
        break;
      case SEND_BTN_STATUS.ACTIVE:
        this._sendBtn.addClass("active");
        this._sendBtn.removeClass("sending");
        this._sendBtn.removeClass("done");
        break;
      case SEND_BTN_STATUS.SENDING:
        this._sendBtn.removeClass("active");
        this._sendBtn.addClass("sending");
        this._sendBtn.removeClass("done");
        break;
      case SEND_BTN_STATUS.DONE:
        this._sendBtn.removeClass("active");
        this._sendBtn.removeClass("sending");
        this._sendBtn.addClass("done");
        break;
      default:
        this._sendBtn.removeClass("active");
        this._sendBtn.removeClass("sending");
        this._sendBtn.removeClass("done");
    }
  }

  // --------------------------------------------------------------------------------------------------------------------------------------
  // --	スコア送信
  // --------------------------------------------------------------------------------------------------------------------------------------

  sendScore() {
    //SE
    AsseetsManager.instance.playSound("sound_click");

    //DOM の　input 要素
    const $inputElm: JQuery = $("#name-input");

    // 文字列チェック用の正規表現
    const alloweStrings: RegExp = /[^A-Za-z]+/;

    const inputText: string = String($inputElm.val());
    let text: string = inputText.replace(alloweStrings, "");
    if (text !== "") {
      RankingManager.instance.on("SUCCESS", this.onSuccess.bind(this));
      RankingManager.instance.on("ERROR", this.onError.bind(this));
      RankingManager.instance.sendScore(text, this._score);
    }

    //ステータスを送信中にする
    this._status = SEND_BTN_STATUS.SENDING;

    //ボタンの表示更新
    this.updateSendBtnView();
  }

  onSuccess() {
    //リスナー削除
    RankingManager.instance.off("SUCCESS");
    RankingManager.instance.off("ERROR");

    //ステータスを送信済みにする
    this._status = SEND_BTN_STATUS.DONE;

    //ボタンの表示更新
    this.updateSendBtnView();

    //テキストチェック停止
    this.textCheckStop();
  }

  onError() {
    //リスナー削除
    RankingManager.instance.off("SUCCESS");
    RankingManager.instance.off("ERROR");

    alert("スコアを送信できませんでした。");

    //ステータスを送信済みにする
    this._status = SEND_BTN_STATUS.ACTIVE;

    //ボタンの表示更新
    this.updateSendBtnView();
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default GameOverView;
